import React from "react";
import { colors } from "../../themes/Colors";

const MedicalCard = ({ title, image }) => {
  return (
    <div
      style={{
        height: 150,
        width: 150,
        minWidth: 150,
        maxWidth: 150,
        minHeight: 150,
        maxHeight: 150,
        position: "relative",
        borderRadius: 8,
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        alt={`banner of ${title}`}
        src={image}
        style={{ height: "100%", width: "100%" }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          backgroundColor: colors.white,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 30,
        }}
      >
        <h5
          style={{
            width: "100%",
            // height: "100%",
            textAlign: "center",
            padding: 10,
            // marginTop: 10,
            backgroundColor: colors.bgSecondary,
          }}
        >
          {title}
        </h5>
      </div>
    </div>
  );
};

export default MedicalCard;
